import { render, staticRenderFns } from "./ObjectsTabs.vue?vue&type=template&id=448e24e4&scoped=true&"
import script from "./ObjectsTabs.vue?vue&type=script&lang=js&"
export * from "./ObjectsTabs.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsTabs.vue?vue&type=style&index=0&id=448e24e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448e24e4",
  null
  
)

export default component.exports